import { Injectable } from "@angular/core";
import { LoadingController, LoadingOptions, Loading } from "ionic-angular";

@Injectable()
export class LoadingComponent {

    private modalLoading:Loading;
    private modalIsOpen:boolean;

    constructor(
        public loadingCtrl: LoadingController
    ){
        this.modalIsOpen = false;
    }

    /**
     * Crea un LoadingController
     * @param opts parametros
     */
    public create(opts:LoadingOptions={content: 'Cargando', showBackdrop: false}){

        if(!this.modalIsOpen){
            this.modalLoading = this.loadingCtrl.create(opts);
            this.modalLoading.present();

            this.modalIsOpen = true;
        }
        
    }

    /**
     * Cierra el LoadingController
     */
    public dismiss(){

        if(this.modalIsOpen && this.modalLoading){

            this.modalLoading.dismiss().catch(()=>{});
        }

        this.modalIsOpen = false;
    }

    /**
     * Cierra todos los LoadingControllers abiertos
     */
    public dismissAll(){

        if(this.modalLoading){
            setTimeout(()=>{
                this.modalLoading.dismissAll();
            }, 1000);
            
        }

        this.modalIsOpen = false;
        
    }
    

}


// WEBPACK FOOTER //
// ./src/components/loadingComponent.ts